import UserTile from './UserTile';

export default UserTile;
